var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (Boolean(_setup.quoteMessage) && _setup.props.displayType !== 'audio')?_c('div',{class:{
    'input-quote-container': true,
    'input-quote-container-uni': _setup.isUniFrameWork,
    'input-quote-container-h5': _setup.isH5,
  }},[_c('div',{staticClass:"input-quote-content"},[_c('div',{staticClass:"max-one-line"},[_vm._v(" "+_vm._s(_setup.quoteMessage.nick || _setup.quoteMessage.from)+": "+_vm._s(_setup.quoteContentText)+" ")]),_c(_setup.Icon,{staticClass:"input-quote-close-icon",attrs:{"file":_setup.closeIcon,"width":"11px","height":"11px"},on:{"onClick":_setup.cancelQuote}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }